import axios from 'axios'
import getCSRFToken from '@helpers/getCSRFToken'

const token = getCSRFToken()

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token
}
